import AssignmentSubjectBlock from './template'
export default AssignmentSubjectBlock
